module.exports = __webpack_public_path__ + "static/media/home-category-8.7a4a3616.png";